import { withModuleContext } from '@edreamsodigeo/frontend-core';
import { PrismaProvider } from '@edreamsodigeo/prisma-design-system';

const MODULE_NAMESPACE = 'cabin-bags';

export default withModuleContext({
  namespace: MODULE_NAMESPACE,
  PrismaProvider,
});
